import React, { useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { toast } from "sonner";
import { Delete } from "lucide-react";

const UNLOCK_KEY = "velta_pin_unlocked";

export default function PinLockScreen({ children }) {
  const { user, setSession } = useAuth() || {};
  const [unlocked, setUnlocked] = useState(() => {
    try { return sessionStorage.getItem(UNLOCK_KEY) === "1"; } catch { return false; }
  });
  const [pin, setPin] = useState("");
  const [busy, setBusy] = useState(false);

  if (!user || unlocked) return children;

  const press = (k) => {
    if (busy) return;
    let next = pin;
    if (k === "C") next = "";
    else if (k === "←") next = pin.slice(0, -1);
    else if (pin.length < 4) next = pin + k;
    setPin(next);
    if (next.length === 4) submit(next);
  };

  const submit = async (value) => {
    const p = value || pin;
    if (p.length !== 4) return;
    setBusy(true);
    try {
      const r = await api.post("/auth/pin-switch", { pin: p });
      setSession(r.data.token, r.data.user);
      try { sessionStorage.setItem(UNLOCK_KEY, "1"); } catch { /* ignore */ }
      setUnlocked(true);
      toast.success(`Operatore: ${r.data.user.name}`);
    } catch (e) {
      toast.error(e?.response?.data?.detail || "PIN errato");
      setPin("");
    } finally {
      setBusy(false);
    }
  };

  const skipOwner = () => {
    try { sessionStorage.setItem(UNLOCK_KEY, "1"); } catch { /* ignore */ }
    setUnlocked(true);
  };

  return (
    <div className="h-screen bg-velta-bg flex flex-col items-center justify-center p-4" data-testid="pin-lock-screen">
      <div className="w-full max-w-sm bg-white border border-velta-border rounded-md p-6">
        <div className="text-[10px] font-mono uppercase tracking-widest text-velta-mute">Palmare sala</div>
        <h1 className="font-heading text-2xl font-semibold mb-1">Sblocco operatore</h1>
        <p className="text-sm text-velta-mute mb-4">PIN a 4 cifre. Traccia chi apre i tavoli e chi invia le comande.</p>
        <div className="bg-velta-bg border border-velta-border rounded-md py-5 mb-4 text-center font-mono text-4xl tracking-[0.5em]">
          {pin.padEnd(4, "·")}
        </div>
        <div className="grid grid-cols-3 gap-2">
          {["1", "2", "3", "4", "5", "6", "7", "8", "9", "C", "0", "←"].map((k) => (
            <button
              key={k}
              type="button"
              data-testid={`pin-lock-key-${k}`}
              onClick={() => press(k)}
              disabled={busy}
              className="h-14 rounded-md font-mono font-bold text-2xl border border-velta-border bg-white btn-tactile"
            >
              {k === "←" ? <Delete className="w-5 h-5 mx-auto" /> : k}
            </button>
          ))}
        </div>
        <button type="button" className="mt-4 w-full text-sm text-velta-mute underline" onClick={skipOwner}>
          Continua come {user.name}
        </button>
      </div>
    </div>
  );
}
